export default async function () {
    const containers = document.querySelectorAll('.js-weglot');

    if (!containers.length) {
        return;
    }

    await new Promise(resolve => { // eslint-disable-line compat/compat
        const interval = setInterval(() => {
            if (('Weglot' in window) === false) {
                return;
            }

            if (!Weglot.initialized) { // eslint-disable-line no-undef
                return;
            }

            clearInterval(interval);

            resolve();
        });
    });

    const createLink = (langTo, langHost) => {
        const link = document.createElement('a');
        link.text = Weglot.getLanguageName(langTo); // eslint-disable-line no-undef

        const url = new URL(window.location.href);
        url.host = langHost;
        link.href = url.href;

        const classes = [ 'language-toggle__item', 'no-translate' ];

        if (langTo === Weglot.getCurrentLang()) { // eslint-disable-line no-undef
            classes.push('is-active');
        }

        link.classList.add(...classes);

        return link;
    }

    for (const container of containers) {
        container.appendChild(
            createLink(Weglot.options.language_from, Weglot.options.host) // eslint-disable-line no-undef
        );

        for (const language of Weglot.options.languages) { // eslint-disable-line no-undef
            if (!language.enabled) {
                continue;
            }

            let langHost = null;

            if (language.connect_host_destination?.host) {
                langHost = language.connect_host_destination.host;
            }

            if (!langHost) {
                continue;
            }

            container.appendChild(
                createLink(language.language_to, langHost)
            );
        }
    }
}
